/**
 * Shared spacing and type for marketing content sections, so the SEO pages
 * keep one rhythm instead of each section picking its own sizes.
 */
export const SECTION_CLASS = 'landing-width mb-24 w-full px-4 md:mb-32 md:px-8';

/** Section H2: matches the home page's section headings. */
export const SECTION_HEADING_CLASS =
	'landing-heading text-balance text-center !text-[28px] tracking-tight md:!text-[40px]';

/** One-line lead under a section H2. */
export const SECTION_LEAD_CLASS =
	'mx-auto mt-4 max-w-2xl text-pretty text-center text-base leading-relaxed text-secondary md:text-lg';

/** Bordered card used for grids of short items. */
export const SECTION_CARD_CLASS = 'rounded-xl border border-border bg-background p-5';
